import { createApiUrl, getToken, generateQueryParams } from '../../util';
import { API_ERROR_CODES, PARENT_EVENTS } from '../../constants/index';
import api from 'api/axiosInstance';

type GetDesignReqQParams = {
	uuid: string;
	panelKey?: string;
}

async function getDesignByExternalID(externalId: string, panelKey?: string) {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};
	const apiUrl = `/designs/design-by-externalId${generateQueryParams({ externalId, panelKey: panelKey ? encodeURIComponent(panelKey as string) : undefined })}`;
	try {
		const { data } = await api.get(createApiUrl(apiUrl), config);
		return data as RawSolarQueryData;
	} catch (error: any) {
		if (error.response && error.response.status === 400 
				&& error.response.data.errorCode === API_ERROR_CODES.DESIGN_DELETED) {
			window.parent.postMessage({ 
				id: PARENT_EVENTS.DESIGN_HAS_RESET, 
				detail: error.response.data,
			}, '*');
		}
		throw error;
	}
}

async function getDesignByUUID(qparamsObj: GetDesignReqQParams) {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};

	qparamsObj.panelKey = qparamsObj.panelKey ? encodeURIComponent(qparamsObj.panelKey) : undefined;

	const apiUrl = `/designs/design-by-uuid${generateQueryParams({ ...removeUndefinedKeys(qparamsObj) })}`;

	try {
		const { data } = await api.get(createApiUrl(apiUrl), config);
		return data as RawSolarQueryData;
	} catch (error: any) {
		if (error.response && error.response.status === 400 
			&& error.response.data.errorCode === API_ERROR_CODES.DESIGN_DELETED) {
			window.parent.postMessage({ 
				id: PARENT_EVENTS.DESIGN_HAS_RESET, 
				detail: error.response.data,
			}, '*');
		}
		throw error;
	}
}

async function getRoofDesignByUUID(qparamsObj: GetDesignReqQParams) {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};

	qparamsObj.panelKey = qparamsObj.panelKey ? encodeURIComponent(qparamsObj.panelKey) : undefined;

	const apiUrl = `/designs/roof/design-by-uuid${generateQueryParams({ ...removeUndefinedKeys(qparamsObj) })}`;

	try {
		const { data } = await api.get(createApiUrl(apiUrl), config);
		return data as RawSolarQueryData;
	} catch (error: any) {
		if (error.response && error.response.status === 400 
			&& error.response.data.errorCode === API_ERROR_CODES.DESIGN_DELETED) {
			window.parent.postMessage({ 
				id: PARENT_EVENTS.DESIGN_HAS_RESET, 
				detail: error.response.data,
			}, '*');
		}
		throw error;
	}
}

function removeUndefinedKeys<T extends Record<string, any>>(payload: T): T {
	return Object.fromEntries(
		Object.entries(payload).filter(([_, value]) => value !== undefined)
	) as T;
}

export {
	getDesignByExternalID,
	getDesignByUUID,
	getRoofDesignByUUID
};
